import { Link, useParams } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Check, Home as HomeIcon } from "lucide-react";

export default function Success() {
  const { code } = useParams();
  return (
    <div data-testid="success-page" className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-xl w-full text-center">
          <div className="mx-auto w-20 h-20 bg-rb-red flex items-center justify-center mb-8">
            <Check className="w-10 h-10 text-white" strokeWidth={3} />
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold mb-5 text-rb-ink">
            تم استلام طلب عضويتك
          </h1>
          <p className="text-rb-textMuted text-base leading-loose mb-8">
            شكراً لانضمامك إلى نادي RB100. ستقوم لجنة النادي بمراجعة طلبك،
            وسيصلك إشعار العضوية عبر واتساب بعد الاعتماد.
          </p>
          <div className="bg-rb-surface border border-rb-border p-8 mb-8">
            <div className="text-xs tracking-[0.3em] text-rb-textMuted uppercase mb-3">
              رقم المرجع الخاص بك
            </div>
            <div data-testid="success-reference-code" className="font-heading text-3xl sm:text-4xl font-extrabold text-rb-red tracking-widest">
              {code}
            </div>
            <div className="text-xs text-rb-textMuted mt-4">
              احتفظ بهذا الرقم لمتابعة حالة طلبك
            </div>
          </div>
          <Link
            to="/"
            data-testid="success-back-home"
            className="inline-flex items-center gap-2 border border-rb-border hover:border-rb-red hover:text-rb-red text-rb-ink px-6 py-3 transition-colors"
          >
            <HomeIcon className="w-4 h-4" />
            العودة للرئيسية
          </Link>
          <Link
            to={`/track?ref=${code}`}
            data-testid="success-check-status"
            className="inline-flex items-center gap-2 mr-3 bg-rb-red hover:bg-rb-redHover text-white font-bold px-6 py-3 transition-colors"
          >
            تتبّع حالة الطلب
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
